<template>
  <div class="commission-detail main-container">
    <loading :isShow="pageLoading" />
    <div class="header">
      <span>产品名称：{{ pageQuery.name }}</span>
      <span>产品编码： {{ pageQuery.code || '-' }}</span>
      <span>保司：{{ productBase.companyName || '-' }}</span>
      <span v-if="$units.superviseShowVal()">供应商：{{ productBase.supplierName || '-' }}</span>
      <Button v-if="pageQuery.editType != 3 || !isEdit" @click="back()" type="primary" ghost>返回</Button>
    </div>
    <div class="btnBox clearfix">
      <div class="fir" v-if="!isEdit">
        <div class="version-wrap left" v-if="pageQuery.versionNo">有效期：{{ pageQuery.versionStartTime || '-' }} 至 {{ pageQuery.versionEndTime || '-' }}</div>
        <div class="right">
          <Button v-if="pageQuery.sourceType == 2" type="primary" @click="showEdit()">编辑</Button>
        </div>
      </div>
    </div>

    <commissionDetail v-show="!isEdit" ref="commissionDetailRef"></commissionDetail>
    <editRateTable
      ref="editRateTable"
      v-show="isEdit"
      :productInfo="pageQuery"
      :productAdditions="productAdditions"
      :programBases="programBases"
      :templateId="templateId"
      @success="refreshData"
      @cancel="cancel"
    ></editRateTable>
    <!-- 修改确认弹窗 -->
    <confirm-modal ref="confirmModal" @save="saveEdit"></confirm-modal>
  </div>
</template>
  
  <script>
import { common } from '@/api/mixins';
import upLoad from '@/components/commons/upload';
import { getCommissionTabs } from '@/api/httpList';
import editRateTable from './components/editRateTable';
import commissionDetail from './components/commissionDetail';
import rateTable from '@/components/commons/feeTemplate/rateTable';
import confirmModal from '@/components/commons/feeTemplate/confirmModal';
export default {
  mixins: [common],
  components: {
    upLoad,
    rateTable,
    confirmModal,
    editRateTable,
    commissionDetail
  },
  props: {
    pageType: null // modal 弹窗模式
  },
  data() {
    return {
      isEdit: false, //是否编辑
      pageLoading: false,
      productBase: {
        companyName: '',
        supplierName: ''
      },
      templateId: '', //模板Id
      templateType: '', //模板类型
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      productAdditions: [], //主险附加险
      programBases: [], //方案列表
      version: {}, //版本信息
      pageQuery: {
        versionStartTime: '',
        versionEndTime: '',
        versionNo: '',
        versionType: ''
      }
    };
  },
  async created() {
    this.pageQuery = this.$route.query;
    this.setPageTitle(this.pageQuery.editType == 3 ? '复制并创建新版本' : '费用配置详情');
    await this.queryGradeTreeByPlatformId();
    this.querySupplyInfos();
    await this.getCommissionTemplate();
    if (this.pageQuery.editType == 3) {
      this.isEdit = true;
      this.$refs.editRateTable.init(this.pageQuery, this.pageQuery.editType);
    } else {
      this.isEdit = false;
      this.$refs.commissionDetailRef.init(JSON.parse(JSON.stringify({ ...this.pageQuery, productCode: this.pageQuery.code })));
    }
  },
  methods: {
    refreshData(data) {
      if (data.versionNo) {
        this.pageQuery.versionNo = data.versionNo;
        this.pageQuery.versionStartTime = data.versionStartTime;
        this.pageQuery.versionEndTime = data.versionEndTime;
        this.pageQuery.id = data.id;
        this.pageQuery.editType = this.pageQuery.editType == 3 ? 2 : this.pageQuery.editType;
        // editType 1编辑或新增当前版本  2编辑未来版本   3复制当前版本新增未来版本
      }
      this.$refs.commissionDetailRef.init(JSON.parse(JSON.stringify({ ...this.pageQuery, productCode: this.pageQuery.code })));
      this.isEdit = false;
    },
    querySupplyInfos() {
      this.$http({
        url: '/buz/upcommission/querySupplyInfos',
        type: 'GET',
        data: {
          productCode: this.pageQuery.code
        }
      }).then(res => {
        this.productBase = res.data;
      });
    },
    queryGradeTreeByPlatformId() {
      return this.$http({
        url: '/buz/programBase/queryGradeTreeById',
        type: 'GET',
        data: {
          id: this.pageQuery.productId,
          programType: this.pageQuery.productCategory == 3 ? 1 : 2
        }
      }).then(res => {
        this.productAdditions = res.data.productAdditions; //主险&&附加险
        this.programBases = res.data.programBases; //所有方案
      });
    },
    // 显示编辑按钮
    showEdit() {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.isEdit = true;
      this.$refs.editRateTable.init(this.pageQuery, this.pageQuery.editType);
    },
    // 打开确认弹窗
    openConfirmModal(data) {
      this.$refs.confirmModal.open(data);
    },
    /**
     * data 待保存数据
     * reload 是否需要刷新
     */
    saveEdit(data, reload = true) {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      if (this.pageLoading) {
        return;
      }
      this.pageLoading = true;
      return this.$http({
        url: '/buz/commission/sys/modify',
        type: 'POST',
        data: {
          templateId: this.templateId,
          templateType: this.templateType,
          productCode: this.pageQuery.code,
          commissionList: data.list
        }
      })
        .then(res => {
          if (reload) {
            this.$Message.success('保存成功');
            this.isEdit = false;
            this.$refs.commissionDetailRef.init(JSON.parse(JSON.stringify({ ...this.pageQuery, productCode: this.pageQuery.code })));
          }
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    saveSort(data) {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$http({
        url: '/buz/commission/sortNew',
        type: 'POST',
        data: {
          productCode: this.pageQuery.code,
          versionNo: this.pageQuery.versionNo,
          commissionSortItems: data.list
        }
      }).then(res => {
        this.$refs.commissionDetailRef.init(JSON.parse(JSON.stringify({ ...this.pageQuery, productCode: this.pageQuery.code })));
      });
    },
    async getCommissionTemplate() {
      let res = await getCommissionTabs(this.pageQuery.code);
      if (res.data) {
        this.templateId = res.data[0].id;
        this.templateType = res.data[0].templateType;
      }
    },
    // 删除交费年限
    async delYear(params) {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      const data = this.$refs.table.getSaveData();
      if (data) {
        await this.saveEdit(data, false);
      }
      if (this.pageLoading) {
        return;
      }
      this.pageLoading = true;
      this.$http({
        url: '/buz/upcommission/delCommissionNum',
        type: 'POST',
        data: { ...params, versionNo: this.pageQuery.versionNo }
      })
        .then(async res => {
          this.$refs.commissionDetailRef.init(JSON.parse(JSON.stringify({ ...this.pageQuery, productCode: this.pageQuery.code })));
          window.setTimeout(() => {
            if (this.isEdit) {
              this.$refs.table.showEdit();
            }
          }, 100);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    // 新增交费年限
    async addYear(params) {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      const data = this.$refs.table.getSaveData();
      if (data) {
        await this.saveEdit(data, false);
      }
      if (this.pageLoading) {
        return;
      }
      this.pageLoading = true;
      this.$http({
        url: '/buz/upcommission/addCommissionNum',
        type: 'POST',
        data: { ...params, versionNo: this.pageQuery.versionNo }
      })
        .then(async res => {
          this.$refs.commissionDetailRef.init(JSON.parse(JSON.stringify({ ...this.pageQuery, productCode: this.pageQuery.code })));
          window.setTimeout(() => {
            if (this.isEdit) {
              this.$refs.table.showEdit();
            }
            $('.last-td')[0].scrollIntoView({ inline: 'end' });
          }, 100);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    cancel() {
      if (this.pageQuery.editType == 3) {
        this.back();
      } else {
        this.isEdit = false;
        this.$refs.commissionDetailRef.init(JSON.parse(JSON.stringify({ ...this.pageQuery, productCode: this.pageQuery.code })));
      }
    },
    // 设置至交费期满
    async setFullYear(params) {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      const data = this.$refs.table.getSaveData();
      if (data) {
        await this.saveEdit(data, false);
      }
      if (this.pageLoading) {
        return;
      }
      const untilLast = params.untilLast;
      delete params.untilLast;
      this.pageLoading = true;
      this.$http({
        url: untilLast ? '/buz/upcommission/setCommissionUntilLast' : '/buz/upcommission/cancelCommissionUntilLast',
        type: 'POST',
        data: { ...params, versionNo: this.pageQuery.versionNo }
      })
        .then(async res => {
          this.$refs.commissionDetailRef.init(JSON.parse(JSON.stringify({ ...this.pageQuery, productCode: this.pageQuery.code })));
          window.setTimeout(() => {
            if (this.isEdit) {
              this.$refs.table.showEdit();
            }
          }, 100);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    }
  }
};
</script>
  <style lang="scss" scoped>
.commission-detail {
  .version-wrap {
    margin-bottom: 10px;
  }
  .btn-left {
    position: absolute;
    left: 40px;
  }
  position: relative;

  .info-text {
    color: #ff7134;
    white-space: pre-line;
  }

  .tableBox {
    table {
      width: 100%;
      border-collapse: collapse;

      input {
        // width: 100px;
      }

      thead {
        background: #f8f8f9;
      }

      th {
        border: 1px solid #eee;
        width: 100px;
        padding: 10px 10px;
      }

      td {
        text-align: center;
        border: 1px solid #eee;
        padding: 10px 10px;
      }
    }
  }

  .link {
    color: #236dff;
    cursor: pointer;
  }

  /deep/ .ivu-table-cell {
    padding-left: 0;
    padding-right: 0;
    height: 100%;
    display: flex;
    color: #3c464f;
    font-size: 14px;
    justify-content: center;
    align-items: center;
  }

  /deep/ .ivu-table-cell {
    line-height: 1;
  }

  .header {
    font-size: 14px;
    color: #333;
    margin-bottom: 36px;
    padding-right: 70px;
    position: relative;
    span {
      margin-right: 50px;
    }
    .ivu-btn {
      position: absolute;
      right: 0;
    }
  }

  .tag {
    margin-left: 10px;
    color: #515c6f;
    font-size: 12px;
    background: #e3e5e8;
    border-radius: 4px;
    width: 50px;
    display: inline-block;
    height: 20px;
    text-align: center;
    line-height: 20px;
    border: 1px solid #ced1d5;
    margin-top: 5px;

    &.active {
      background: #fff0ea;
      color: #ff7134;
      border: 1px solid #ff7134;
    }
  }

  background: #fff;

  .upLoadBox {
    margin-left: 30px;
    margin-bottom: 30px;
  }

  /deep/ .btn {
    color: #236dff;
    float: left;
    margin-right: 20px;

    &:hover {
      cursor: pointer;
    }
  }

  .btnBox {
    width: 100%;
    text-align: right;
    margin-bottom: 10px;
    margin-top: 10px;
    // position: absolute;
    // right: 20px;
    z-index: 1;

    .fir {
      .left {
        float: left;
      }

      .right {
        float: right;
      }
    }
  }
  .pageBox {
    margin-top: 20px;
  }

  .activity-info {
    span {
      margin-right: 20px;
    }
  }
  .station-box {
    height: 40px;
  }
}
</style>